module.exports = {
    acesso_externo: 'Acesso Externo',
    aetitle: 'STT AE Title',
    arquitetura: 'Arquitetura',
    atividades: 'Atividades',
    atividadesPendentes: 'Atividades Pendentes',
    ativo: 'Ativo',
    automacao: 'Automação',
    bridge_aetitle: 'Bridge AE Title',
    bridges: 'BRIDGE',
    comandos: 'Comandos',
    comandoReenviadaSucesso: 'Comando reenviado com sucesso!',
    comandoSelecionado: 'comando selecionado',
    comandosSelecionados: 'comandos selecionados',
    consultaAvancada: 'Consulta Avançada',
    copiadoPayload: 'Payload copiado',
    copiarPayload: 'Copiar payload',
    dataAcao: 'Data da ação',
    dataCriacao: 'Data da criação',
    dataExecucao: 'Data de execução',
    dataFinalCriacao: 'Data final da criação',
    dataFinalAtualizacao: 'Data final da atualização',
    dataInicialCriacao: 'Data inicial da criação',
    dataInicialAtualizacao: 'Data inicial da atualização',
    dataPrimeiroExame: 'Data do primeiro exame',
    dataUltimaAcao: 'Data da última ação',
    dataUltimaAtualizacao: 'Data da última atualização',
    descricaoIgnorarAlerta: 'Tem certeza que deseja marcar este alerta como ignorado?',
    descricaoReenviarNovamente: 'Tem certeza que deseja submeter a operação novamente?',
    descricaoResolverAlerta: 'Você está prestes a marcar este alerta como resolvido. Por favor, descreva o motivo da resolução abaixo para fins de auditoria.',
    descricaoTentarNovamente: 'Deseja submeter a operação novamente?*',
    detalhesComando: 'Detalhes do Comando',
    distribuicaoSituacaoAlertas: 'Distribuição de Situação',
    erroAlertaNaoEncontrado: 'Alerta não encontrado',
    erroAoIgnorarAlerta: 'Erro ao ignorar alerta',
    erroAoReenviarComando: 'Erro ao reenviar comando. Tente novamente mais tarde.',
    erroAoReenviarInvalidacao: 'Erro ao reenviar invalidação. Tente novamente mais tarde.',
    erroConsultaAvancadaInvalida: 'Consulta avançada inválida. As chaves devem ter aspas. Exemplo: {"payload.pacs_aetitle": "PACS_HGCR"}',
    erroConsultaAvancadaDeveSerObjeto: 'A consulta avançada deve ser um objeto JSON. Exemplo: {"payload.pacs_aetitle": "PACS_HGCR"}',
    erroDesconhecido: 'Erro desconhecido',
    examesAgendados: 'Exames Agendados',
    fila: 'Fila',
    id: 'ID',
    identificador: 'Identificador',
    identificadorComando: 'ID (Identificador do comando)',
    ignorados: 'Ignorados',
    ignorarAlerta: 'Ignorar Alerta',
    incluirHousekeeping: 'Mostrar comandos automáticos',
    informacaoConsultaAvancada: 'Insira um objeto JSON para pesquisar diretamente no MongoDB. Exemplo: {"payload.pacs_aetitle": "PACS_HGCR"}',
    informacoesGerais: 'Informações gerais',
    integracaoExames: 'Integrações de Exames',
    invalidacaoReenviadaSucesso: 'Invalidação reenviada com sucesso!',
    invalidacoes: 'Invalidações',
    ip: 'IP',
    logs: 'Logs',
    mensagem: 'Mensagem',
    modalidade: 'Modalidade',
    nao: 'Não',
    nome: 'Nome',
    notificacao: 'Notificação',
    novaArquiteturaInstalada: 'Nova arquitetura instalada',
    novaArquiteturaNaoInstalada: 'Não foi instalado completamente a nova arquitetura',
    numeroExame: 'Número do exame',
    pacs: 'PACS',
    pacs_aetitle: 'STT AE Title',
    payload: 'Payload',
    pendentes: 'Pendentes',
    placeholderResolverAlerta: 'Descreva as ações tomadas...',
    porta: 'Porta',
    processado: 'Processado?',
    recuparacaoExames: 'Recuperação de Exames',
    recuperar: 'Recuperar',
    reenviarNovamente: 'Reenviar novamente',
    resolverAlerta: 'Resolver Alerta',
    resolvidos: 'Resolvidos',
    sim: 'Sim',
    software: 'Software',
    stack: 'Stack',
    stacktrace: 'Stacktrace',
    status: 'Status',
    statusAtual: 'Status atual',
    stt: 'STT',
    stt_aetitle: 'STT AE Title',
    tem_nats: 'Arquitetura',
    timelineEventos: 'Timeline de eventos',
    tipo: 'Tipo',
    tipoPacs: 'Tipo PACS',
    tituloStacktrace: 'Detalhes do erro',
    tituloVisualizacao: 'Visualização de histórico',
    ultimaAtualizacao: 'Última atualização',
    ultimoStatus: 'Último status',
    url: 'URL',
    urlPacs: 'URL PACS',
    urlRecuperacao: 'URL de recuperação',
    verStacktrace: 'Ver stacktrace',
    versao: 'Versão',
    versao_dcm4chee: 'Versão',
    visaoGeral: 'Visão Geral dos últimos 30 dias',
    volumeAlertas: 'Integrações',

    // Visão geral - Detalhes da atividade
    detalhesAtividade: 'Detalhes da atividade',
    detalhes: 'Detalhes',
    instituicao: 'Instituição',
    situacao: 'Situação',
    data: 'Data',
    ultimaAlteracao: 'Última alteração',
    exclusaoNoPacs: 'Exclusão no PACS',
    excluido: 'Excluído',
    naoExcluido: 'Não excluído',
    excluidoRestaurado: 'Excluído e restaurado',
    motivoResolucao: 'Motivo da resolução',
    historicoEventos: 'Histórico de eventos',
    nenhumRegistroEncontrado: 'Nenhum registro encontrado.',
    restaurar: 'Restaurar',
    excluir: 'Excluir',
    ignorar: 'Ignorar',
    confirmarExclusaoTitulo: 'Deseja realmente excluir este exame do PACS?',
    confirmarExclusaoDescricao: 'Esta ação enviará um comando de exclusão e não poderá ser desfeita.',
    restaurarExame: 'Restaurar exame',
    descricaoRestaurarExame: 'Deseja realmente restaurar este exame no PACS? Um comando de restauração será enviado.',
    erroAoResolverAlerta: 'Erro ao enviar exclusão para o PACS. Tente novamente mais tarde.',
    erroAoRestaurarAlerta: 'Erro ao restaurar exame. Tente novamente mais tarde.',
    erroGenerico: 'Ocorreram os seguintes erros:',
    todos: 'Todos',
    filtrar: 'Filtrar',
    limpar: 'Limpar',
    linhasPorPagina: 'Linhas por página',
    de: 'de',

    // DICOM Hub
    titulo: 'DICOM Hub',
    subtitulo: 'Baixe o aplicativo desktop e conecte sua sessão do Gestão PACS ao DICOM Hub local.',
    windowsOnly: 'Disponível apenas para Windows',
    statusAplicativo: 'Aplicativo desktop',
    verificando: 'Verificando aplicativo local...',
    aplicativoAtivo: 'Aplicativo ativo',
    aplicativoNaoDetectado: 'Aplicativo não detectado nesta máquina.',
    aplicativoPronto: 'Tudo certo: sua sessão pode ser conectada ao DICOM Hub local.',
    passosInstalacao: '1. Baixe a versão para Windows. 2. Execute o instalador. 3. Volte e clique em Logar no aplicativo desktop.',
    verificarNovamente: 'Verificar novamente',
    conectando: 'Conectando...',
    logarAplicativo: 'Logar no aplicativo desktop',
    downloadTitulo: 'Download para Windows',
    downloadDescricao: 'Use a versão mais recente ou escolha uma versão anterior disponível.',
    tentarNovamente: 'Tentar novamente',
    semVersoes: 'Nenhuma versão para Windows foi publicada ainda.',
    maisRecente: 'Mais recente',
    publicadaEm: 'Publicada em',
    observacao: 'Observação',
    dataPublicacao: 'Publicação',
    artefatos: 'Artefatos',
    acoes: 'Ações',
    adminTitulo: 'Administração de versões',
    adminDescricao: 'Publique, substitua ou remova artefatos do aplicativo desktop.',
    atualizar: 'Atualizar',
    publicarVersao: 'Publicar versão',
    historico: 'Histórico',
    nenhumaVersaoAdmin: 'Nenhuma versão cadastrada.',
    semArtefatosAtivos: 'sem artefatos ativos',
    remover: 'Remover',
    verHistorico: 'Ver histórico',
    selecionarArquivo: 'Selecionar arquivo',
    cancelar: 'Cancelar',
    publicar: 'Publicar',
    fechar: 'Fechar',
    erro: 'Erro',
    sucesso: 'Sucesso',
    substituirArtefato: 'Substituir artefato existente',
    confirmarSubstituicao: 'Confirmar a substituição preservará o histórico anterior e publicará este novo arquivo como artefato ativo.',
    substituir: 'Substituir',
    removerArtefato: 'Remover artefato',
    remocaoSoftDelete: 'O arquivo não será apagado do MinIO, mas deixará de aparecer para download.',
    motivoRemocao: 'Motivo da remoção',
    historicoVersao: 'Histórico da versão',
    dataAtualizacao: 'Atualização',
    semHistorico: 'Nenhum evento registrado.',
    usuario: 'Usuário',
    objectNameAnterior: 'objectName anterior',
    preparandoUpload: 'Preparando upload',
    calculandoChecksum: 'Calculando checksum',
    enviandoArquivoUpload: 'Enviando arquivo',
    confirmandoPublicacao: 'Confirmando publicação',
    uploadSucesso: 'Versão publicada com sucesso.',
    conflitoUpload: 'Já existe um artefato ativo para esta versão e tipo.',
    erroUpload: 'Não foi possível publicar a versão.',
    remocaoSucesso: 'Artefato removido com sucesso.',
    erroRemover: 'Não foi possível remover o artefato.',
    erroListarVersoes: 'Não foi possível carregar as versões disponíveis.',
    erroListarAdmin: 'Não foi possível carregar a administração de versões.',
    naoConfirmouAbertura: 'Não foi possível confirmar se o aplicativo abriu. Instale ou abra o DICOM Hub manualmente e tente novamente.',
    erroDownload: 'Não foi possível gerar o link de download.',
    versaoInvalida: 'Informe uma versão semver válida, como 1.2.0 ou 1.2.0-beta.1.',
    observacaoObrigatoria: 'Informe a observação da versão.',
    arquivoObrigatorioDicom: 'Selecione um arquivo.',
    extensaoInvalida: (extensao) => `Selecione um arquivo ${extensao.toUpperCase()}.`,

    Pacs: {
        instrucaoSTT: `<span>O <strong>PACS/STT</strong> é responsável pelo armazenamento e disponibilização dos exames de imagem médica via protocolo <strong>DICOMweb</strong>, integrando-se aos módulos de exames do STT.</span>
    <span>• <strong>Visualização:</strong> atua como provedor para os visualizadores integrados (<strong>OHIF</strong>, <strong>Oviyam</strong> e <strong>Weasis</strong>) e disponibiliza a funcionalidade de download dos estudos.</span>
    <span>• <strong>Acesso externo:</strong> disponibilizado com acesso via internet para permitir a consulta e visualização de exames de qualquer localidade.</span>`,
        instrucaoBridge: `<span>O <strong>PACS/BRIDGE</strong> disponibiliza o protocolo DICOM tradicional e atua como intermediário entre os equipamentos de saúde e o PACS/STT.</span>
    <span>• <strong>Ponto de recepção:</strong> primeiro contato com as modalidades para recepção e encaminhamento dos exames ao PACS/STT.</span>
    <span>• <strong>Modo BRIDGE:</strong> opera em rede local (sem exposição à internet) e repassa os dados obrigatoriamente ao PACS/STT.</span>`,
        infoRenomearEstudo: 'Esta operação irá renomear os dados do paciente <strong>em paralelo</strong> no PACS/BRIDGE e no PACS/STT. Ambos os processamentos ocorrerão simultaneamente.',

        // Renomear Estudo
        tituloRenomearEstudo: 'Renomear Estudo DICOM',
        dadosDoEstudo: 'Dados do Estudo',
        studyInstanceUid: 'Study Instance UID',
        studyInstanceUidHelper: 'UID do estudo DICOM a ser renomeado',
        studyInstanceUidPlaceholder: '1.2.840.113619.2.55.3.123456789.123',
        confirmarRenomeacao: 'Confirmar Renomeação',
        confirmarDadosRenomeacao: 'Confirmar Dados da Renomeação',
        processandoRenomeacaoParalelo: 'Processando renomeação em paralelo...',
        sucessoRenomeacao: 'Estudo DICOM renomeado com sucesso em ambos os sistemas!',

        // Upload Estudo
        tituloUploadEstudo: 'DICOM Upload',
        dadosDoPaciente: 'Dados do Paciente',
        enviarEstudo: 'Enviar Estudo',
        enviando: 'Enviando...',
        arquivoDoEstudo: 'Arquivo do Estudo',
        selecionarArquivoZip: 'Selecionar Arquivo .ZIP',
        arrasteOuCliqueUpload: 'Arraste ou clique para fazer upload',
        tamanhoMaximoArquivo: 'Tamanho máximo: 500MB. Apenas arquivos compactados.',
        revisaoDados: 'Revisão dos Dados',
        processandoEstudo: 'Processando estudo...',
        concluido: 'Concluído',
        sucessoUpload: 'Estudo DICOM processado com sucesso!',
        aguardando: 'aguardando',
        enviandoArquivo: 'Enviando arquivo...',

        // Campos comuns
        confirmacao: 'Confirmação',
        idPaciente: 'ID do Paciente',
        idPacientePlaceholder: 'CPF ou CNS',
        nomePaciente: 'Nome do Paciente',
        nomePacientePlaceholder: 'Nome Completo',
        sexo: 'Sexo',
        selecione: 'Selecione',
        naoInformado: 'Não informado',
        masculino: 'Masculino',
        feminino: 'Feminino',
        outro: 'Outro',
        dataNascimento: 'Data de Nascimento',
        arquivo: 'Arquivo',

        // Botões
        cancelar: 'Cancelar',
        voltar: 'Voltar',
        proximo: 'Próximo',

        // Status e processamento
        bridgePacs: 'Bridge PACS',
        sttPacs: 'STT PACS',
        statusLabel: 'Status:',
        labelStatus: 'Status',
        pendente: 'pendente',
        sucesso: 'Sucesso',
        erro: 'Erro',
        jobId: 'Job ID:',

        // Mensagens de validação e erro
        preencherCamposObrigatorios: 'Por favor, preencha todos os campos obrigatórios',
        preencherCamposObrigatoriosCorretos: 'Por favor, preencha todos os campos obrigatórios corretamente.',
        idPacienteObrigatorio: 'ID do paciente é obrigatório',
        nomePacienteObrigatorio: 'Nome do paciente é obrigatório',
        arquivoObrigatorio: 'Arquivo é obrigatório',
        apenasArquivosZip: 'Apenas arquivos .zip são permitidos',
        erroEnviarEstudo: 'Erro ao enviar estudo DICOM',

        // Cadastro/Edição de Bridge
        cadastrarBridge: 'Cadastrar bridge',
        editarBridge: 'Editar bridge',
        salvarBridge: 'Salvar',
        salvandoBridge: 'Salvando...',
        infoCadastroBridge: 'Selecione o PACS, informe os dados da bridge e escolha as modalidades para concluir o cadastro.',
        erroCarregarFormularioBridge: 'Não foi possível carregar os dados do formulário de bridge.',
        erroSalvarBridge: 'Não foi possível salvar a bridge.',
        bridgeCadastradaSucesso: 'Bridge cadastrada com sucesso.',
        bridgeAtualizadaSucesso: 'Bridge atualizada com sucesso.',
        camposObrigatoriosBridge: 'Preencha PACS, IP, AE Title, CNES e ao menos uma modalidade.',
        natsSubject: 'NATS Subject',
        cnes: 'CNES',
        modalidades: 'Modalidades',

        // Opções da grid de Bridge
        verPontos: 'Ver pontos',
        ping: 'Ping',
        uploadEstudo: 'Upload estudo',
        renomearEstudo: 'Renomear estudo',
        erroConexaoBridge: (bridgeAetitle) => `Não foi possível conectar ao Bridge ${bridgeAetitle}.`
    }
};
